<template>
    <div>This is a protion details page</div>
</template>

<script>
export default {
    name: "Promotion"
}
</script>